import React, { memo } from "react";
import ItemProduction from "./ItemProduction";
import ApiData from "../../api/ApiData";
import { observer } from "mobx-react-lite";

const LisrProduction = observer(
  ({ getSoftProductionFunc, moveSoftProductionFunc }) => {
    return (
      <div className="sites-list container-list-this">
        {ApiData.company.productions.map((itemproduction) => (
          <ItemProduction
            key={itemproduction.id}
            itemproduction={itemproduction}
            getSoftProductionFunc={getSoftProductionFunc}
            moveSoftProductionFunc={moveSoftProductionFunc}
          />
        ))}
      </div>
    );
  }
);

export default memo(LisrProduction);
